export const pageUrlGenerator = (page) =>
  `${window.location.protocol}//${window.location.host}${page}`;

export const QtechGames = {
  spribe: {
    aviator: {
      redirectUrl: "/casino/spribe/aviator",
      code: "aviator",
      casino: "spribe",
      provider: "aviator",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Aviator.webp",
      alt: "",
      name: "Aviator",
      providerName: "Spribe",
    },
    mines: {
      redirectUrl: "/casino/spribe/mines",
      code: "mines",
      casino: "spribe",
      provider: "mines",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Mines.webp",
      alt: "",
      name: "Mines",
      providerName: "Spribe",
    },
    goal: {
      redirectUrl: "/casino/spribe/goal",
      code: "goal",
      casino: "spribe",
      provider: "goal",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Goal.webp",
      alt: "",
      name: "Goal",
      providerName: "Spribe",
    },
    dice: {
      redirectUrl: "/casino/spribe/dice",
      code: "dice",
      casino: "spribe",
      provider: "dice",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Dice.webp",
      alt: "",
      name: "Dice",
      providerName: "Spribe",
    },
    plinko: {
      redirectUrl: "/casino/spribe/plinko",
      code: "plinko",
      casino: "spribe",
      provider: "plinko",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Plinko.webp",
      alt: "",
      name: "Plinko",
      providerName: "Spribe",
    },
    miniroulette: {
      redirectUrl: "/casino/spribe/miniroulette",
      code: "mini-roulette",
      casino: "spribe",
      provider: "mini-roulette",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/MiniROulette.webp",
      alt: "",
      name: "Mini Roulette",
      providerName: "Spribe",
    },
    hilo: {
      redirectUrl: "/casino/spribe/hilo",
      code: "hi-lo",
      casino: "spribe",
      provider: "hi-lo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Hilo.webp",
      alt: "",
      name: "Hilo",
      providerName: "Spribe",
    },
    keno: {
      redirectUrl: "/casino/spribe/keno",
      code: "keno",
      casino: "spribe",
      provider: "keno",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/keno.webp",
      alt: "keno",
      name: "Keno",
      providerName: "Spribe",
    },
    hotline: {
      redirectUrl: "/casino/spribe/hotline",
      code: "hotline",
      casino: "spribe",
      provider: "hotline",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/hotline.webp",
      alt: "hotline",
      name: "hotline",
      providerName: "Spribe",
    },
  },

  // turbo: {
  //   aero: {
  //     redirectUrl: "/casino/qtechturbogames-aero",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/Aero.webp",
  //     alt: "",
  //     name: "Aero",
  //     providerName: "Turbo Games",
  //   },
  //   BallAndBall: {
  //     redirectUrl: "/casino/qtechturbogames-ball-and-ball",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/Ball&Ball.webp",
  //     alt: "",
  //     name: "Ball & Ball",
  //     providerName: "Turbo Games",
  //   },
  //   Bayraktar: {
  //     redirectUrl: "/casino/qtechturbogames-bayraktar",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/Bayraktar.webp",
  //     alt: "",
  //     name: "Bayraktar",
  //     providerName: "Turbo Games",
  //   },
  //   Bubbles: {
  //     redirectUrl: "/casino/qtechturbogames-bubbles",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/Bubbles.webp",
  //     alt: "",
  //     name: "Bubbles",
  //     providerName: "Turbo Games",
  //   },
  //   crashX: {
  //     redirectUrl: "/casino/qtechturbogames-crash-x",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/CrashX.webp",
  //     alt: "",
  //     name: "Crash X",
  //     providerName: "Turbo Games",
  //   },
  //   CrashXFootballEdition: {
  //     redirectUrl: "/casino/qtechturbogames-crash-x-football-edition",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/CrashXFootballEdition.webp",
  //     alt: "",
  //     name: "Crash X Football Edition",
  //     providerName: "Turbo Games",
  //   },
  //   DiceTwice: {
  //     redirectUrl: "/casino/qtechturbogames-dice-twice",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/DiceTwice.webp",
  //     alt: "",
  //     name: "Dice Twice",
  //     providerName: "Turbo Games",
  //   },
  //   DogsStreet: {
  //     redirectUrl: "/casino/qtechturbogames-dogs-street",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/DogsStreet.webp",
  //     alt: "",
  //     name: "Dogs' Street",
  //     providerName: "Turbo Games",
  //   },
  //   DoubleRoll: {
  //     redirectUrl: "/casino/qtechturbogames-double-roll",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/DoubleRoll.webp",
  //     alt: "",
  //     name: "Double Roll",
  //     providerName: "Turbo Games",
  //   },
  //   FastFielder: {
  //     redirectUrl: "/casino/qtechturbogames-fast-fielder",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/FastFielder.webp",
  //     alt: "",
  //     name: "Fast Fielder",
  //     providerName: "Turbo Games",
  //   },
  //   FruitTowers: {
  //     redirectUrl: "/casino/qtechturbogames-fruit-towers",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/FruitTowers.webp",
  //     alt: "",
  //     name: "Fruit Towers",
  //     providerName: "Turbo Games",
  //   },
  //   Hamsta: {
  //     redirectUrl: "/casino/qtechturbogames-hamsta",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/Hamsta.webp",
  //     alt: "",
  //     name: "Hamsta",
  //     providerName: "Turbo Games",
  //   },
  //   HiLo: {
  //     redirectUrl: "/casino/qtechturbogames-hi-lo",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/Hi-Lo.webp",
  //     alt: "",
  //     name: "Hi-Lo",
  //     providerName: "Turbo Games",
  //   },
  //   JavelinX: {
  //     redirectUrl: "/casino/qtechturbogames-javelinx",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/JavelinX.webp",
  //     alt: "",
  //     name: "JavelinX",
  //     providerName: "Turbo Games",
  //   },
  //   LimboRider: {
  //     redirectUrl: "/casino/qtechturbogames-limbo-rider",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/LimboRider.webp",
  //     alt: "",
  //     name: "Limbo Rider",
  //     providerName: "Turbo Games",
  //   },
  //   Mines: {
  //     redirectUrl: "/casino/qtechturbogames-mines",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/Mines.webp",
  //     alt: "",
  //     name: "Mines",
  //     providerName: "Turbo Games",
  //   },
  //   Neko: {
  //     redirectUrl: "/casino/qtechturbogames-neko",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/Neko.webp",
  //     alt: "",
  //     name: "Neko",
  //     providerName: "Turbo Games",
  //   },
  //   SaveThePrincess: {
  //     redirectUrl: "/casino/qtechturbogames-save-the-princess",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/SaveThePrincess.webp",
  //     alt: "",
  //     name: "Save the Princess",
  //     providerName: "Turbo Games",
  //   },
  //   SpinStrike: {
  //     redirectUrl: "/casino/qtechturbogames-spin-strike",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/SpinStrike.webp",
  //     alt: "",
  //     name: "Spin Strike",
  //     providerName: "Turbo Games",
  //   },
  //   Stairs: {
  //     redirectUrl: "/casino/qtechturbogames-stairs",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/Stairs.webp",
  //     alt: "",
  //     name: "Stairs",
  //     providerName: "Turbo Games",
  //   },
  //   TradingDice: {
  //     redirectUrl: "/casino/qtechturbogames-trading-dice",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/TradingDice.webp",
  //     alt: "",
  //     name: "Trading Dice",
  //     providerName: "Turbo Games",
  //   },
  //   Towers: {
  //     redirectUrl: "/casino/qtechturbogames-towers",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/Towers.webp",
  //     alt: "",
  //     name: "Towers",
  //     providerName: "Turbo Games",
  //   },
  //   TurboMines: {
  //     redirectUrl: "/casino/qtechturbogames-turbo-mines",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/TurboMines.webp",
  //     alt: "",
  //     name: "Turbo Mines",
  //     providerName: "Turbo Games",
  //   },
  //   TurboPlinko: {
  //     redirectUrl: "/casino/qtechturbogames-turbo-plinko",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/TurboPlinko.webp",
  //     alt: "",
  //     name: "Turbo Plinko",
  //     providerName: "Turbo Games",
  //   },
  //   WicketBlast: {
  //     redirectUrl: "/casino/qtechturbogames-wicket-blast",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/WicketBlast.webp",
  //     alt: "",
  //     name: "Wicket Blast",
  //     providerName: "Turbo Games",
  //   },
  //   MagicKeno: {
  //     redirectUrl: "/casino/qtechturbogames-magic-keno",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/MagicKeno.webp",
  //     alt: "",
  //     name: "Magic Keno",
  //     providerName: "Turbo Games",
  //   },
  //   Vortex: {
  //     redirectUrl: "/casino/qtechturbogames-vortex",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/Vortex.webp",
  //     alt: "",
  //     name: "Vortex",
  //     providerName: "Turbo Games",
  //   },
  //   Tap1MinesU6564: {
  //     redirectUrl: "/casino/qtechturbogames-1tap-mines-u6564",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/1TapMines(InstantWin).webp",
  //     alt: "",
  //     name: "1Tap Mines",
  //     providerName: "Turbo Games",
  //   },
  //   TakeMyPlinko: {
  //     redirectUrl: "/casino/qtechturbogames-take-my-plinko-u2745",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/TakeMyPlinko.webp",
  //     alt: "",
  //     name: "Take My Plinko",
  //     providerName: "Turbo Games",
  //   },
  //   Tap1Mines: {
  //     redirectUrl: "/casino/qtechturbogames-1tap-mines",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/1TapMines.webp",
  //     alt: "",
  //     name: "1Tap Mines (Instant Win)",
  //     providerName: "Turbo Games",
  //   },
  //   DiceThrice: {
  //     redirectUrl: "/casino/qtechturbogames-dice-thrice",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/DiceThrice.webp",
  //     alt: "",
  //     name: "Dice Thrice",
  //     providerName: "Turbo Games",
  //   },
  //   PumpedX: {
  //     redirectUrl: "/casino/qtechturbogames-pumpedx",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/PumpedX.webp",
  //     alt: "",
  //     name: "PumpedX",
  //     providerName: "Turbo Games",
  //   },
  //   DonnyKing: {
  //     redirectUrl: "/casino/qtechturbogames-donny-king",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/DonnyKing.webp",
  //     alt: "",
  //     name: "Donny King",
  //     providerName: "Turbo Games",
  //   },
  //   CrystalPoker: {
  //     redirectUrl: "/casino/qtechturbogames-crystal-poker",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/CrystalPoker.webp",
  //     alt: "",
  //     name: "Crystal Poker",
  //     providerName: "Turbo Games",
  //   },
  //   MultiplayerMines: {
  //     redirectUrl: "/casino/qtechturbogames-multiplayer-mines",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/MultiplayerMines.webp",
  //     alt: "",
  //     name: "Multiplayer Mines",
  //     providerName: "Turbo Games",
  //   },
  //   BookOfMines: {
  //     redirectUrl: "/casino/qtechturbogames-book-of-mines",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/BookOfMines.webp",
  //     alt: "",
  //     name: "Book of Mines",
  //     providerName: "Turbo Games",
  //   },
  //   JewelClicker: {
  //     redirectUrl: "/casino/qtechturbogames-jewel-clicker",
  //     code: "",
  //     casino: "Turbo Games",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/turbo/JewelClicker.webp",
  //     alt: "",
  //     name: "Jewel Clicker",
  //     providerName: "Turbo Games",
  //   },

  //   // name: "Turbo",
  //   // key: "turbo",
  // },

  turbo: {
    aero: {
      redirectUrl: "/casino/aggapturbogames-aero",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/Aero.webp",
      alt: "Aero",
      name: "Aero",
      providerName: "Turbo Games",
    },
    BallAndBall: {
      redirectUrl: "/casino/aggapturbogames-ball-and-ball",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/Ball&Ball.webp",
      alt: "Ball & Ball",
      name: "Ball & Ball",
      providerName: "Turbo Games",
    },
    Bayraktar: {
      redirectUrl: "/casino/aggapturbogames-bayraktar",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/Bayraktar.webp",
      alt: "Bayraktar",
      name: "Bayraktar",
      providerName: "Turbo Games",
    },
    Bubbles: {
      redirectUrl: "/casino/aggapturbogames-bubbles",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/Bubbles.webp",
      alt: "Bubbles",
      name: "Bubbles",
      providerName: "Turbo Games",
    },
    crashX: {
      redirectUrl: "/casino/aggapturbogames-crash-x",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/CrashX.webp",
      alt: "Crash X",
      name: "Crash X",
      providerName: "Turbo Games",
    },
    CrashXFootballEdition: {
      redirectUrl: "/casino/aggapturbogames-crash-x-football-edition",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/CrashXFootballEdition.webp",
      alt: "Crash X Football Edition",
      name: "Crash X Football Edition",
      providerName: "Turbo Games",
    },
    DiceTwice: {
      redirectUrl: "/casino/aggapturbogames-dice-twice",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/DiceTwice.webp",
      alt: "Dice Twice",
      name: "Dice Twice",
      providerName: "Turbo Games",
    },
    DogsStreet: {
      redirectUrl: "/casino/aggapturbogames-dogs-street",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/DogsStreet.webp",
      alt: "Dogs' Street",
      name: "Dogs' Street",
      providerName: "Turbo Games",
    },
    DoubleRoll: {
      redirectUrl: "/casino/aggapturbogames-double-roll",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/DoubleRoll.webp",
      alt: "Double Roll",
      name: "Double Roll",
      providerName: "Turbo Games",
    },
    FastFielder: {
      redirectUrl: "/casino/aggapturbogames-fast-fielder",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/FastFielder.webp",
      alt: "Fast Fielder",
      name: "Fast Fielder",
      providerName: "Turbo Games",
    },
    FruitTowers: {
      redirectUrl: "/casino/aggapturbogames-fruit-towers",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/FruitTowers.webp",
      alt: "Fruit Towers",
      name: "Fruit Towers",
      providerName: "Turbo Games",
    },
    Hamsta: {
      redirectUrl: "/casino/aggapturbogames-hamsta",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/Hamsta.webp",
      alt: "Hamsta",
      name: "Hamsta",
      providerName: "Turbo Games",
    },
    HiLo: {
      redirectUrl: "/casino/aggapturbogames-hi-lo",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/Hi-Lo.webp",
      alt: "Hi-Lo",
      name: "Hi-Lo",
      providerName: "Turbo Games",
    },
    JavelinX: {
      redirectUrl: "/casino/aggapturbogames-javelinx",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/JavelinX.webp",
      alt: "JavelinX",
      name: "JavelinX",
      providerName: "Turbo Games",
    },
    LimboRider: {
      redirectUrl: "/casino/aggapturbogames-limbo-rider",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/LimboRider.webp",
      alt: "Limbo Rider",
      name: "Limbo Rider",
      providerName: "Turbo Games",
    },
    Mines: {
      redirectUrl: "/casino/aggapturbogames-mines",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/Mines.webp",
      alt: "Mines",
      name: "Mines",
      providerName: "Turbo Games",
    },
    Neko: {
      redirectUrl: "/casino/aggapturbogames-neko",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/Neko.webp",
      alt: "Neko",
      name: "Neko",
      providerName: "Turbo Games",
    },
    SaveThePrincess: {
      redirectUrl: "/casino/aggapturbogames-save-the-princess",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/SaveThePrincess.webp",
      alt: "Save the Princess",
      name: "Save the Princess",
      providerName: "Turbo Games",
    },
    SpinStrike: {
      redirectUrl: "/casino/aggapturbogames-spin-strike",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/SpinStrike.webp",
      alt: "Spin Strike",
      name: "Spin Strike",
      providerName: "Turbo Games",
    },
    Stairs: {
      redirectUrl: "/casino/aggapturbogames-fury-stairs",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/Stairs.webp",
      alt: "Stairs",
      name: "Stairs",
      providerName: "Turbo Games",
    },
    TradingDice: {
      redirectUrl: "/casino/aggapturbogames-trading-dice",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/TradingDice.webp",
      alt: "Trading Dice",
      name: "Trading Dice",
      providerName: "Turbo Games",
    },
    Towers: {
      redirectUrl: "/casino/aggapturbogames-towers",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/Towers.webp",
      alt: "Towers",
      name: "Towers",
      providerName: "Turbo Games",
    },
    TurboMines: {
      redirectUrl: "/casino/aggapturbogames-turbo-mines",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/TurboMines.webp",
      alt: "Turbo Mines",
      name: "Turbo Mines",
      providerName: "Turbo Games",
    },
    TurboPlinko: {
      redirectUrl: "/casino/aggapturbogames-turbo-plinko",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/TurboPlinko.webp",
      alt: "Turbo Plinko",
      name: "Turbo Plinko",
      providerName: "Turbo Games",
    },
    WicketBlast: {
      redirectUrl: "/casino/aggapturbogames-wicket-blast",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/WicketBlast.webp",
      alt: "Wicket Blast",
      name: "Wicket Blast",
      providerName: "Turbo Games",
    },
    MagicKeno: {
      redirectUrl: "/casino/aggapturbogames-magic-keno",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/MagicKeno.webp",
      alt: "Magic Keno",
      name: "Magic Keno",
      providerName: "Turbo Games",
    },
    Vortex: {
      redirectUrl: "/casino/aggapturbogames-vortex",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/Vortex.webp",
      alt: "Vortex",
      name: "Vortex",
      providerName: "Turbo Games",
    },
    Tap1Mines: {
      redirectUrl: "/casino/aggapturbogames-1tap-mines",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/1TapMines(InstantWin).webp",
      alt: "1Tap Mines",
      name: "1Tap Mines",
      providerName: "Turbo Games",
    },
    TakeMyPlinko: {
      redirectUrl: "/casino/aggapturbogames-take-my-plinko",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/TakeMyPlinko.webp",
      alt: "Take My Plinko",
      name: "Take My Plinko",
      providerName: "Turbo Games",
    },
    Tap1MinesIW: {
      redirectUrl: "/casino/qt-1tap-mines",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/1TapMines.webp",
      alt: "1Tap Mines (Instant Win)",
      name: "1Tap Mines (Instant Win)",
      providerName: "Turbo Games",
    },
    DiceThrice: {
      redirectUrl: "/casino/aggapturbogames-dice-thrice",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/DiceThrice.webp",
      alt: "Dice Thrice",
      name: "Dice Thrice",
      providerName: "Turbo Games",
    },
    PumpedX: {
      redirectUrl: "/casino/aggapturbogames-pumpedx",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/PumpedX.webp",
      alt: "PumpedX",
      name: "PumpedX",
      providerName: "Turbo Games",
    },
    DonnyKing: {
      redirectUrl: "/casino/aggapturbogames-donny-king",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/DonnyKing.webp",
      alt: "Donny King",
      name: "Donny King",
      providerName: "Turbo Games",
    },
    CrystalPoker: {
      redirectUrl: "/casino/aggapturbogames-crystal-poker",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/CrystalPoker.webp",
      alt: "Crystal Poker",
      name: "Crystal Poker",
      providerName: "Turbo Games",
    },
    MultiplayerMines: {
      redirectUrl: "/casino/aggapturbogames-multiplayer-mines",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/MultiplayerMines.webp",
      alt: "Multiplayer Mines",
      name: "Multiplayer Mines",
      providerName: "Turbo Games",
    },
    BookOfMines: {
      redirectUrl: "/casino/aggapturbogames-book-of-mines",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/BookOfMines.webp",
      alt: "Book of Mines",
      name: "Book of Mines",
      providerName: "Turbo Games",
    },
    JewelClicker: {
      redirectUrl: "/casino/aggapturbogames-jewel-clicker",
      code: "",
      casino: "Turbo Games",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/turbo/JewelClicker.webp",
      alt: "Jewel Clicker",
      name: "Jewel Clicker",
      providerName: "Turbo Games",
    },
  },

  // hacksaw: {
  //   SCRATCHPlatinum: {
  //     redirectUrl: "/casino/qtechhacksawgaming-scratch-platinum",
  //     code: "",
  //     casino: "Hacksaw",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/hacksaw/SCRATCHPlatinum.webp",
  //     alt: "",
  //     name: "SCRATCH! Platinum",
  //     providerName: "Hacksaw",
  //   },
  //   SCRATCHGold: {
  //     redirectUrl: "/casino/qtechhacksawgaming-scratch-gold",
  //     code: "",
  //     casino: "Hacksaw",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/hacksaw/SCRATCHGold.webp",
  //     alt: "",
  //     name: "SCRATCH! Gold",
  //     providerName: "Hacksaw",
  //   },
  //   SCRATCHSilver: {
  //     redirectUrl: "/casino/qtechhacksawgaming-scratch-silver",
  //     code: "",
  //     casino: "Hacksaw",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/hacksaw/SCRATCHSilver.webp",
  //     alt: "",
  //     name: "SCRATCH! Silver",
  //     providerName: "Hacksaw",
  //   },
  //   SCRATCHBronze: {
  //     redirectUrl: "/casino/qtechhacksawgaming-scratch-bronze",
  //     code: "",
  //     casino: "Hacksaw",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/hacksaw/SCRATCHBronze.webp",
  //     alt: "",
  //     name: "SCRATCH! Bronze",
  //     providerName: "Hacksaw",
  //   },
  //   SnowScratcher: {
  //     redirectUrl: "/casino/qtechhacksawgaming-snow-scratcher",
  //     code: "",
  //     casino: "Hacksaw",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/hacksaw/SnowScratcher.webp",
  //     alt: "",
  //     name: "Snow Scratcher",
  //     providerName: "Hacksaw",
  //   },
  //   SummerScratch: {
  //     redirectUrl: "/casino/qtechhacksawgaming-summer-scratch",
  //     code: "",
  //     casino: "Hacksaw",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/hacksaw/SummerScratch.webp",
  //     alt: "",
  //     name: "Summer Scratch",
  //     providerName: "Hacksaw",
  //   },
  //   Express200Scratch: {
  //     redirectUrl: "/casino/qtechhacksawgaming-express-200-scratch",
  //     code: "",
  //     casino: "Hacksaw",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/hacksaw/Express200Scratch.webp",
  //     alt: "",
  //     name: "Express 200 Scratch",
  //     providerName: "Hacksaw",
  //   },
  //   ScratchyMini: {
  //     redirectUrl: "/casino/qtechhacksawgaming-scratchy-mini",
  //     code: "",
  //     casino: "Hacksaw",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/hacksaw/ScratchyMini.webp",
  //     alt: "",
  //     name: "Scratchy Mini",
  //     providerName: "Hacksaw",
  //   },
  //   Scratchy: {
  //     redirectUrl: "/casino/qtechhacksawgaming-scratchy",
  //     code: "",
  //     casino: "Hacksaw",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/hacksaw/Scratchy.webp",
  //     alt: "",
  //     name: "Scratchy",
  //     providerName: "Hacksaw",
  //   },
  //   ScratchyBig: {
  //     redirectUrl: "/casino/qtechhacksawgaming-scratchy-big",
  //     code: "",
  //     casino: "Hacksaw",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/hacksaw/ScratchyBig.webp",
  //     alt: "",
  //     name: "Scratchy Big",
  //     providerName: "Hacksaw",
  //   },
  //   KingTreasure: {
  //     redirectUrl: "/casino/qtechhacksawgaming-king-treasure",
  //     code: "",
  //     casino: "Hacksaw",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/hacksaw/KingTreasure.webp",
  //     alt: "",
  //     name: "King Treasure",
  //     providerName: "Hacksaw",
  //   },
  //   QueenTreasure: {
  //     redirectUrl: "/casino/qtechhacksawgaming-queen-treasure",
  //     code: "",
  //     casino: "Hacksaw",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/hacksaw/QueenTreasure.webp",
  //     alt: "",
  //     name: "Queen Treasure",
  //     providerName: "Hacksaw",
  //   },
  //   PrinceTreasure: {
  //     redirectUrl: "/casino/qtechhacksawgaming-prince-treasure",
  //     code: "",
  //     casino: "Hacksaw",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/hacksaw/PrinceTreasure.webp",
  //     alt: "",
  //     name: "Prince Treasure",
  //     providerName: "Hacksaw",
  //   },
  //   HappyScratch: {
  //     redirectUrl: "/casino/qtechhacksawgaming-happy-scratch",
  //     code: "",
  //     casino: "Hacksaw",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/hacksaw/Happyscratch.webp",
  //     alt: "",
  //     name: "Happy Scratch",
  //     providerName: "Hacksaw",
  //   },
  //   LOVEIsAllYouNeed: {
  //     redirectUrl: "/casino/qtechhacksawgaming-love-is-all-you-need",
  //     code: "",
  //     casino: "Hacksaw",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/hacksaw/LoveIsAllYouNeed.webp",
  //     alt: "",
  //     name: "LOVE is all you need",
  //     providerName: "Hacksaw",
  //   },
  //   LuckyScratch: {
  //     redirectUrl: "/casino/qtechhacksawgaming-lucky-scratch",
  //     code: "",
  //     casino: "Hacksaw",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/hacksaw/Luckyscratch.webp",
  //     alt: "",
  //     name: "Lucky Scratch",
  //     providerName: "Hacksaw",
  //   },
  //   CashPool: {
  //     redirectUrl: "/casino/qtechhacksawgaming-cash-pool",
  //     code: "",
  //     casino: "Hacksaw",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/hacksaw/Cashpool.webp",
  //     alt: "",
  //     name: "Cash Pool",
  //     providerName: "Hacksaw",
  //   },
  //   CashScratch: {
  //     redirectUrl: "/casino/qtechhacksawgaming-cash-scratch",
  //     code: "",
  //     casino: "Hacksaw",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/hacksaw/CashScratch.webp",
  //     alt: "",
  //     name: "Cash Scratch",
  //     providerName: "Hacksaw",
  //   },
  //   ChaosCrewScratch: {
  //     redirectUrl: "/casino/qtechhacksawgaming-chaos-crew-scratch",
  //     code: "",
  //     casino: "Hacksaw",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/hacksaw/ChaosCrewScratch.webp",
  //     alt: "",
  //     name: "Chaos Crew Scratch",
  //     providerName: "Hacksaw",
  //   },
  //   DreamCarUrban: {
  //     redirectUrl: "/casino/qtechhacksawgaming-dream-car-urban",
  //     code: "",
  //     casino: "Hacksaw",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/hacksaw/DreamCarUrban.webp",
  //     alt: "",
  //     name: "Dream Car Urban",
  //     providerName: "Hacksaw",
  //   },
  //   DreamCarSUV: {
  //     redirectUrl: "/casino/qtechhacksawgaming-dream-car-suv",
  //     code: "",
  //     casino: "Hacksaw",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/hacksaw/DreamCarSUV.webp",
  //     alt: "",
  //     name: "Dream Car SUV",
  //     providerName: "Hacksaw",
  //   },
  //   DreamCarSpeed: {
  //     redirectUrl: "/casino/qtechhacksawgaming-dream-car-speed",
  //     code: "",
  //     casino: "Hacksaw",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/hacksaw/DreamCarSpeed.webp",
  //     alt: "",
  //     name: "Dream Car Speed",
  //     providerName: "Hacksaw",
  //   },
  //   EggstraCash: {
  //     redirectUrl: "/casino/qtechhacksawgaming-eggstra-cash",
  //     code: "",
  //     casino: "Hacksaw",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/hacksaw/EggstraCash.webp",
  //     alt: "",
  //     name: "Eggstra Cash",
  //     providerName: "Hacksaw",
  //   },
  //   FootballScratch: {
  //     redirectUrl: "/casino/qtechhacksawgaming-football-scratch",
  //     code: "",
  //     casino: "Hacksaw",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/hacksaw/FootballScratch.webp",
  //     alt: "",
  //     name: "Football Scratch",
  //     providerName: "Hacksaw",
  //   },
  //   GoldRush: {
  //     redirectUrl: "/casino/qtechhacksawgaming-gold-rush",
  //     code: "",
  //     casino: "Hacksaw",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/hacksaw/GoldRush.webp",
  //     alt: "",
  //     name: "Gold Rush",
  //     providerName: "Hacksaw",
  //   },
  //   RubyRush: {
  //     redirectUrl: "/casino/qtechhacksawgaming-ruby-rush",
  //     code: "",
  //     casino: "Hacksaw",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/hacksaw/RubyRush.webp",
  //     alt: "",
  //     name: "Ruby Rush",
  //     providerName: "Hacksaw",
  //   },
  //   DiamondRush: {
  //     redirectUrl: "/casino/qtechhacksawgaming-diamond-rush",
  //     code: "",
  //     casino: "Hacksaw",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/hacksaw/DiamondRush.webp",
  //     alt: "",
  //     name: "Diamond Rush",
  //     providerName: "Hacksaw",
  //   },
  //   LuckyShot: {
  //     redirectUrl: "/casino/qtechhacksawgaming-lucky-shot",
  //     code: "",
  //     casino: "Hacksaw",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/hacksaw/LuckyShot.webp",
  //     alt: "",
  //     name: "Lucky Shot",
  //     providerName: "Hacksaw",
  //   },
  //   CashVaultI: {
  //     redirectUrl: "/casino/qtechhacksawgaming-cash-vault-i",
  //     code: "",
  //     casino: "Hacksaw",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/hacksaw/CashVaultI.webp",
  //     alt: "",
  //     name: "Cash Vault I",
  //     providerName: "Hacksaw",
  //   },
  //   CashVaultII: {
  //     redirectUrl: "/casino/qtechhacksawgaming-cash-vault-ii",
  //     code: "",
  //     casino: "Hacksaw",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/hacksaw/CashVaultII.webp",
  //     alt: "",
  //     name: "Cash Vault II",
  //     providerName: "Hacksaw",
  //   },
  // },

  hacksaw: {
    SCRATCHPlatinum: {
      redirectUrl: "/casino/qt-scratch-platinum",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/SCRATCHPlatinum.webp",
      alt: "SCRATCH! Platinum",
      name: "SCRATCH! Platinum",
      providerName: "Hacksaw",
    },
    SCRATCHGold: {
      redirectUrl: "/casino/qt-scratch-gold",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/SCRATCHGold.webp",
      alt: "SCRATCH! Gold",
      name: "SCRATCH! Gold",
      providerName: "Hacksaw",
    },
    SCRATCHSilver: {
      redirectUrl: "/casino/qt-scratch-silver",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/SCRATCHSilver.webp",
      alt: "SCRATCH! Silver",
      name: "SCRATCH! Silver",
      providerName: "Hacksaw",
    },
    SCRATCHBronze: {
      redirectUrl: "/casino/qt-scratch-bronze",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/SCRATCHBronze.webp",
      alt: "SCRATCH! Bronze",
      name: "SCRATCH! Bronze",
      providerName: "Hacksaw",
    },
    SnowScratcher: {
      redirectUrl: "/casino/qt-snow-scratcher",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/SnowScratcher.webp",
      alt: "Snow Scratcher",
      name: "Snow Scratcher",
      providerName: "Hacksaw",
    },
    SummerScratch: {
      redirectUrl: "/casino/qt-summer-scratch",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/SummerScratch.webp",
      alt: "Summer Scratch",
      name: "Summer Scratch",
      providerName: "Hacksaw",
    },
    Express200Scratch: {
      redirectUrl: "/casino/qt-express-200-scratch",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Express200Scratch.webp",
      alt: "Express 200 Scratch",
      name: "Express 200 Scratch",
      providerName: "Hacksaw",
    },
    ScratchyMini: {
      redirectUrl: "/casino/qt-scratchy-mini",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/ScratchyMini.webp",
      alt: "Scratchy Mini",
      name: "Scratchy Mini",
      providerName: "Hacksaw",
    },
    Scratchy: {
      redirectUrl: "/casino/qt-scratchy",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Scratchy.webp",
      alt: "Scratchy",
      name: "Scratchy",
      providerName: "Hacksaw",
    },
    ScratchyBig: {
      redirectUrl: "/casino/qt-scratchy-big",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/ScratchyBig.webp",
      alt: "Scratchy Big",
      name: "Scratchy Big",
      providerName: "Hacksaw",
    },
    KingTreasure: {
      redirectUrl: "/casino/qt-king-treasure",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/KingTreasure.webp",
      alt: "King Treasure",
      name: "King Treasure",
      providerName: "Hacksaw",
    },
    QueenTreasure: {
      redirectUrl: "/casino/qt-queen-treasure",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/QueenTreasure.webp",
      alt: "Queen Treasure",
      name: "Queen Treasure",
      providerName: "Hacksaw",
    },
    PrinceTreasure: {
      redirectUrl: "/casino/qt-prince-treasure",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/PrinceTreasure.webp",
      alt: "Prince Treasure",
      name: "Prince Treasure",
      providerName: "Hacksaw",
    },
    HappyScratch: {
      redirectUrl: "/casino/qt-happy-scratch",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Happyscratch.webp",
      alt: "Happy Scratch",
      name: "Happy Scratch",
      providerName: "Hacksaw",
    },
    LOVEIsAllYouNeed: {
      redirectUrl: "/casino/qt-love-is-all-you-need",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/LoveIsAllYouNeed.webp",
      alt: "LOVE is all you need",
      name: "LOVE is all you need",
      providerName: "Hacksaw",
    },
    LuckyScratch: {
      redirectUrl: "/casino/qt-lucky-scratch",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Luckyscratch.webp",
      alt: "Lucky Scratch",
      name: "Lucky Scratch",
      providerName: "Hacksaw",
    },
    CashPool: {
      redirectUrl: "/casino/qt-cash-pool",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Cashpool.webp",
      alt: "Cash Pool",
      name: "Cash Pool",
      providerName: "Hacksaw",
    },
    CashScratch: {
      redirectUrl: "/casino/qt-cash-scratch",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/CashScratch.webp",
      alt: "Cash Scratch",
      name: "Cash Scratch",
      providerName: "Hacksaw",
    },
    ChaosCrewScratch: {
      redirectUrl: "/casino/qt-chaos-crew-scratch",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/ChaosCrewScratch.webp",
      alt: "Chaos Crew Scratch",
      name: "Chaos Crew Scratch",
      providerName: "Hacksaw",
    },
    DreamCarUrban: {
      redirectUrl: "/casino/qt-dream-car-urban",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/DreamCarUrban.webp",
      alt: "Dream Car Urban",
      name: "Dream Car Urban",
      providerName: "Hacksaw",
    },
    DreamCarSUV: {
      redirectUrl: "/casino/qt-dream-car-suv",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/DreamCarSUV.webp",
      alt: "Dream Car SUV",
      name: "Dream Car SUV",
      providerName: "Hacksaw",
    },
    DreamCarSpeed: {
      redirectUrl: "/casino/qt-dream-car-speed",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/DreamCarSpeed.webp",
      alt: "Dream Car Speed",
      name: "Dream Car Speed",
      providerName: "Hacksaw",
    },
    EggstraCash: {
      redirectUrl: "/casino/qt-eggstra-cash",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/EggstraCash.webp",
      alt: "Eggstra Cash",
      name: "Eggstra Cash",
      providerName: "Hacksaw",
    },
    FootballScratch: {
      redirectUrl: "/casino/qt-football-scratch",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/FootballScratch.webp",
      alt: "Football Scratch",
      name: "Football Scratch",
      providerName: "Hacksaw",
    },
    GoldRush: {
      redirectUrl: "/casino/qt-gold-rush",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/GoldRush.webp",
      alt: "Gold Rush",
      name: "Gold Rush",
      providerName: "Hacksaw",
    },
    RubyRush: {
      redirectUrl: "/casino/qt-ruby-rush",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/RubyRush.webp",
      alt: "Ruby Rush",
      name: "Ruby Rush",
      providerName: "Hacksaw",
    },
    DiamondRush: {
      redirectUrl: "/casino/qt-diamond-rush",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/DiamondRush.webp",
      alt: "Diamond Rush",
      name: "Diamond Rush",
      providerName: "Hacksaw",
    },
    LuckyShot: {
      redirectUrl: "/casino/qt-lucky-shot",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/LuckyShot.webp",
      alt: "Lucky Shot",
      name: "Lucky Shot",
      providerName: "Hacksaw",
    },
    CashVaultI: {
      redirectUrl: "/casino/qt-cash-vault-i",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/CashVaultI.webp",
      alt: "Cash Vault I",
      name: "Cash Vault I",
      providerName: "Hacksaw",
    },
    CashVaultII: {
      redirectUrl: "/casino/qt-cash-vault-ii",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/CashVaultII.webp",
      alt: "Cash Vault II",
      name: "Cash Vault II",
      providerName: "Hacksaw",
    },
    CrazyDonuts: {
      redirectUrl: "/casino/qt-crazy-donuts",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/CrazyDonuts.webp",
      alt: "Crazy Donuts",
      name: "Crazy Donuts",
      providerName: "Hacksaw",
    },
    LuckyNumbersX8: {
      redirectUrl: "/casino/qt-lucky-numbers-x8",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/LuckyNumbersX8.webp",
      alt: "Lucky Numbers x8",
      name: "Lucky Numbers x8",
      providerName: "Hacksaw",
    },
    LuckyNumbersX12: {
      redirectUrl: "/casino/qt-lucky-numbers-x12",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/LuckyNumbersX12.webp",
      alt: "Lucky Numbers x12",
      name: "Lucky Numbers x12",
      providerName: "Hacksaw",
    },
    LuckyNumbersX16: {
      redirectUrl: "/casino/qt-lucky-numbers-x16",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/LuckyNumbersX16.webp",
      alt: "Lucky Numbers x16",
      name: "Lucky Numbers x16",
      providerName: "Hacksaw",
    },
    LuckyNumbersX20: {
      redirectUrl: "/casino/qt-lucky-numbers-x20",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/LuckyNumbersx20.webp",
      alt: "Lucky Numbers x20",
      name: "Lucky Numbers x20",
      providerName: "Hacksaw",
    },
    ItsBananas: {
      redirectUrl: "/casino/qt-its-bananas",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Itsbananas.webp",
      alt: "It's bananas",
      name: "It's bananas",
      providerName: "Hacksaw",
    },
    DoubleSalary1Year: {
      redirectUrl: "/casino/qt-double-salary-1-year",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/DoubleSalary1Year.webp",
      alt: "Double Salary - 1 Year",
      name: "Double Salary - 1 Year",
      providerName: "Hacksaw",
    },
    ShaveTheBeard: {
      redirectUrl: "/casino/qt-shave-the-beard",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/ShaveTheBeard.webp",
      alt: "Shave the Beard",
      name: "Shave the Beard",
      providerName: "Hacksaw",
    },
    CutTheGrass: {
      redirectUrl: "/casino/qt-cut-the-grass",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/CutTheGrass.webp",
      alt: "Cut the Grass",
      name: "Cut the Grass",
      providerName: "Hacksaw",
    },
    Scratchem: {
      redirectUrl: "/casino/qt-scratchem",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Scratchem.webp",
      alt: "Scratch’em",
      name: "Scratch’em",
      providerName: "Hacksaw",
    },
    KoiCash: {
      redirectUrl: "/casino/qt-koi-cash",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/KoiCash.webp",
      alt: "Koi Cash",
      name: "Koi Cash",
      providerName: "Hacksaw",
    },
    BreakTheIce: {
      redirectUrl: "/casino/qt-break-the-ice",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/BreakTheIce.webp",
      alt: "Break the Ice",
      name: "Break the Ice",
      providerName: "Hacksaw",
    },
    GoldCoins: {
      redirectUrl: "/casino/qt-gold-coins",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/GoldCoins.webp",
      alt: "Gold Coins",
      name: "Gold Coins",
      providerName: "Hacksaw",
    },
    FrogsScratch: {
      redirectUrl: "/casino/qt-frogs-scratch",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/FrogsScratch.webp",
      alt: "Frogs Scratch",
      name: "Frogs Scratch",
      providerName: "Hacksaw",
    },
    ShaveTheSheep: {
      redirectUrl: "/casino/qt-shave-the-sheep",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/ShaveTheSheep.webp",
      alt: "Shave the Sheep",
      name: "Shave the Sheep",
      providerName: "Hacksaw",
    },
    SpookyScaryScratchy: {
      redirectUrl: "/casino/qt-spooky-scary-scratchy",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/SpookyScaryScratchy.webp",
      alt: "Spooky Scary Scratchy",
      name: "Spooky Scary Scratchy",
      providerName: "Hacksaw",
    },
    ThePerfectScratch: {
      redirectUrl: "/casino/qt-the-perfect-scratch",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/ThePerfectScratch.webp",
      alt: "The perfect Scratch",
      name: "The perfect Scratch",
      providerName: "Hacksaw",
    },
    TigerScratch: {
      redirectUrl: "/casino/qt-tiger-scratch",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/TigerScratch.webp",
      alt: "Tiger Scratch",
      name: "Tiger Scratch",
      providerName: "Hacksaw",
    },
    RatRiches: {
      redirectUrl: "/casino/qt-rat-riches",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/RatRiches.webp",
      alt: "Rat Riches",
      name: "Rat Riches",
      providerName: "Hacksaw",
    },
    StackEmScratch: {
      redirectUrl: "/casino/qt-stackem-scratch",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/StackEmScratch.webp",
      alt: "Stack'Em Scratch",
      name: "Stack'Em Scratch",
      providerName: "Hacksaw",
    },
    GoPanda: {
      redirectUrl: "/casino/qt-go-panda",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/GoPanda.webp",
      alt: "Go Panda",
      name: "Go Panda",
      providerName: "Hacksaw",
    },
    WantedDeadOrAWild: {
      redirectUrl: "/casino/qt-wanted-dead-or-a-wild",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/WantedDeadOrAWild.webp",
      alt: "Wanted Dead or a Wild",
      name: "Wanted Dead or a Wild",
      providerName: "Hacksaw",
    },
    Wild2Die2: {
      redirectUrl: "/casino/qt-2-wild-2-die",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/2Wild2Die.webp",
      alt: "2 Wild 2 Die",
      name: "2 Wild 2 Die",
      providerName: "Hacksaw",
    },
    Mines: {
      redirectUrl: "/casino/qt-mines",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Mines.webp",
      alt: "Mines",
      name: "Mines",
      providerName: "Hacksaw",
    },
    Coins: {
      redirectUrl: "/casino/qt-coins",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Coins.webp",
      alt: "Coins",
      name: "Coins",
      providerName: "Hacksaw",
    },
    Colors: {
      redirectUrl: "/casino/qt-colors",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Colors.webp",
      alt: "Colors",
      name: "Colors",
      providerName: "Hacksaw",
    },
    Blocks: {
      redirectUrl: "/casino/qt-blocks",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Blocks.webp",
      alt: "Blocks",
      name: "Blocks",
      providerName: "Hacksaw",
    },
    Boxes: {
      redirectUrl: "/casino/qt-boxes",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Boxes.webp",
      alt: "Boxes",
      name: "Boxes",
      providerName: "Hacksaw",
    },
    HiLo: {
      redirectUrl: "/casino/qt-hi-lo",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/HiLo.webp",
      alt: "Hi-Lo",
      name: "Hi-Lo",
      providerName: "Hacksaw",
    },
    Lines: {
      redirectUrl: "/casino/qt-lines",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Lines.webp",
      alt: "Lines",
      name: "Lines",
      providerName: "Hacksaw",
    },
    Plinko: {
      redirectUrl: "/casino/qt-plinko",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Plinko.webp",
      alt: "Plinko",
      name: "Plinko",
      providerName: "Hacksaw",
    },
    TwentyOne: {
      redirectUrl: "/casino/qt-twenty-one",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/TwentyOne.webp",
      alt: "Twenty-One",
      name: "Twenty-One",
      providerName: "Hacksaw",
    },
    Wheel: {
      redirectUrl: "/casino/qt-wheel",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Wheel.webp",
      alt: "Wheel",
      name: "Wheel",
      providerName: "Hacksaw",
    },
    XmasDrop: {
      redirectUrl: "/casino/qt-xmas-drop",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/XmasDrop.webp",
      alt: "Xmas Drop",
      name: "Xmas Drop",
      providerName: "Hacksaw",
    },
    DarkSummoning: {
      redirectUrl: "/casino/qt-dark-summoning",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/DarkSummoning.webp",
      alt: "Dark Summoning",
      name: "Dark Summoning",
      providerName: "Hacksaw",
    },
    ImmortalDesire: {
      redirectUrl: "/casino/qt-immortal-desire",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/ImmortalDesire.webp",
      alt: "Immortal Desire",
      name: "Immortal Desire",
      providerName: "Hacksaw",
    },
    EyeOfThePanda: {
      redirectUrl: "/casino/qt-eye-of-the-panda",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/EyeOfThePanda.webp",
      alt: "Eye of the Panda",
      name: "Eye of the Panda",
      providerName: "Hacksaw",
    },
    ChaosCrewII: {
      redirectUrl: "/casino/qt-chaos-crew-ii",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/ChaosCrewII.webp",
      alt: "Chaos Crew II",
      name: "Chaos Crew II",
      providerName: "Hacksaw",
    },
    BennyTheBeer: {
      redirectUrl: "/casino/qt-benny-the-beer",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/BennyTheBeer.webp",
      alt: "Benny the Beer",
      name: "Benny the Beer",
      providerName: "Hacksaw",
    },
    Densho: {
      redirectUrl: "/casino/qt-densho",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Densho.webp",
      alt: "Densho",
      name: "Densho",
      providerName: "Hacksaw",
    },
    LeBandit: {
      redirectUrl: "/casino/qt-le-bandit",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/LeBandit.webp",
      alt: "Le Bandit",
      name: "Le Bandit",
      providerName: "Hacksaw",
    },
    RoninStackways: {
      redirectUrl: "/casino/qt-ronin-stackways",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/RoninStackways.webp",
      alt: "Ronin Stackways",
      name: "Ronin Stackways",
      providerName: "Hacksaw",
    },
    Dropem: {
      redirectUrl: "/casino/qt-dropaeurotmem",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Dropem.webp",
      alt: "Drop’em",
      name: "Drop’em",
      providerName: "Hacksaw",
    },
    VendingMachine: {
      redirectUrl: "/casino/qt-vending-machine",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/VendingMachine.webp",
      alt: "Vending Machine",
      name: "Vending Machine",
      providerName: "Hacksaw",
    },
    BeastBelow: {
      redirectUrl: "/casino/qt-beast-below",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/BeastBelow.webp",
      alt: "Beast Below",
      name: "Beast Below",
      providerName: "Hacksaw",
    },
    MightyMasks: {
      redirectUrl: "/casino/qt-mighty-masks",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/MightyMasks.webp",
      alt: "Mighty Masks",
      name: "Mighty Masks",
      providerName: "Hacksaw",
    },
    AlphaEagle: {
      redirectUrl: "/casino/qt-alpha-eagle",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/AlphaEagle.webp",
      alt: "Alpha Eagle",
      name: "Alpha Eagle",
      providerName: "Hacksaw",
    },
    AztecTwist: {
      redirectUrl: "/casino/qt-aztec-twist",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/AztecTwist.webp",
      alt: "Aztec Twist",
      name: "Aztec Twist",
      providerName: "Hacksaw",
    },
    Bloodthirst: {
      redirectUrl: "/casino/qt-bloodthirst",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Bloodthirst.webp",
      alt: "Bloodthirst",
      name: "Bloodthirst",
      providerName: "Hacksaw",
    },
    BookOfTime: {
      redirectUrl: "/casino/qt-book-of-time",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/BookOfTime.webp",
      alt: "Book of Time",
      name: "Book of Time",
      providerName: "Hacksaw",
    },
    BornWild: {
      redirectUrl: "/casino/qt-born-wild",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/BornWild.webp",
      alt: "Born Wild",
      name: "Born Wild",
      providerName: "Hacksaw",
    },
    BreakBones: {
      redirectUrl: "/casino/qt-break-bones",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/BreakBones.webp",
      alt: "Break Bones",
      name: "Break Bones",
      providerName: "Hacksaw",
    },
    BuffaloStackNSync: {
      redirectUrl: "/casino/qt-buffalo-stack-n-sync",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/BuffaloStackNSync.webp",
      alt: "Buffalo Stack 'n' Sync",
      name: "Buffalo Stack 'n' Sync",
      providerName: "Hacksaw",
    },
    Cubes: {
      redirectUrl: "/casino/qt-cubes",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Cubes.webp",
      alt: "Cubes",
      name: "Cubes",
      providerName: "Hacksaw",
    },
    Cubes2: {
      redirectUrl: "/casino/qt-cubes-2",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Cubes2.webp",
      alt: "Cubes 2",
      name: "Cubes 2",
      providerName: "Hacksaw",
    },
    CursedSeas: {
      redirectUrl: "/casino/qt-cursed-seas",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/CursedSeas.webp",
      alt: "Cursed Seas",
      name: "Cursed Seas",
      providerName: "Hacksaw",
    },
    CashCompass: {
      redirectUrl: "/casino/qt-cash-compass",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/CashCompass.webp",
      alt: "Cash Compass",
      name: "Cash Compass",
      providerName: "Hacksaw",
    },
    CashQuest: {
      redirectUrl: "/casino/qt-cash-quest",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/CashQuest.webp",
      alt: "Cash Quest",
      name: "Cash Quest",
      providerName: "Hacksaw",
    },
    ChaosCrew: {
      redirectUrl: "/casino/qt-chaos-crew",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/ChaosCrew.webp",
      alt: "Chaos Crew",
      name: "Chaos Crew",
      providerName: "Hacksaw",
    },
    DorkUnit: {
      redirectUrl: "/casino/qt-dork-unit",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/DorkUnit.webp",
      alt: "Dork Unit",
      name: "Dork Unit",
      providerName: "Hacksaw",
    },
    DoubleRainbow: {
      redirectUrl: "/casino/qt-double-rainbow",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/DoubleRainbow.webp",
      alt: "Double Rainbow",
      name: "Double Rainbow",
      providerName: "Hacksaw",
    },
    FearTheDark: {
      redirectUrl: "/casino/qt-fear-the-dark",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/FearTheDark.webp",
      alt: "Fear the Dark",
      name: "Fear the Dark",
      providerName: "Hacksaw",
    },
    ForestFortune: {
      redirectUrl: "/casino/qt-forest-fortune",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/ForestFortune.webp",
      alt: "Forest Fortune",
      name: "Forest Fortune",
      providerName: "Hacksaw",
    },
    FranksFarm: {
      redirectUrl: "/casino/qt-franks-farm",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/FranksFarm.webp",
      alt: "Frank's Farm",
      name: "Frank's Farm",
      providerName: "Hacksaw",
    },
    FruitDuel: {
      redirectUrl: "/casino/qt-fruit-duel",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/FruitDuel.webp",
      alt: "Fruit Duel",
      name: "Fruit Duel",
      providerName: "Hacksaw",
    },
    Frutz: {
      redirectUrl: "/casino/qt-frutz",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Frutz.webp",
      alt: "Frutz",
      name: "Frutz",
      providerName: "Hacksaw",
    },
    GladiatorLegends: {
      redirectUrl: "/casino/qt-gladiator-legends",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/GladiatorLegends.webp",
      alt: "Gladiator Legends",
      name: "Gladiator Legends",
      providerName: "Hacksaw",
    },
    GronksGems: {
      redirectUrl: "/casino/qt-gronks-gems",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/GronksGems.webp",
      alt: "Gronk's Gems",
      name: "Gronk's Gems",
      providerName: "Hacksaw",
    },
    HandOfAnubis: {
      redirectUrl: "/casino/qt-hand-of-anubis",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/HandOfAnubis.webp",
      alt: "Hand Of Anubis",
      name: "Hand Of Anubis",
      providerName: "Hacksaw",
    },
    HarvestWilds: {
      redirectUrl: "/casino/qt-harvest-wilds",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/HarvestWilds.webp",
      alt: "Harvest Wilds",
      name: "Harvest Wilds",
      providerName: "Hacksaw",
    },
    HopNpop: {
      redirectUrl: "/casino/qt-hopnpop",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/HopNpop.webp",
      alt: "Hop'n'pop",
      name: "Hop'n'pop",
      providerName: "Hacksaw",
    },
    Itero: {
      redirectUrl: "/casino/qt-itero",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Itero.webp",
      alt: "Itero",
      name: "Itero",
      providerName: "Hacksaw",
    },
    JokerBombs: {
      redirectUrl: "/casino/qt-joker-bombs",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/JokerBombs.webp",
      alt: "Joker Bombs",
      name: "Joker Bombs",
      providerName: "Hacksaw",
    },
    KeepemCool: {
      redirectUrl: "/casino/qt-keep-em-cool",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/KeepemCool.webp",
      alt: "Keep 'em Cool",
      name: "Keep 'em Cool",
      providerName: "Hacksaw",
    },
    KingCarrot: {
      redirectUrl: "/casino/qt-king-carrot",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/KingCarrot.webp",
      alt: "King Carrot",
      name: "King Carrot",
      providerName: "Hacksaw",
    },
    LetItSnow: {
      redirectUrl: "/casino/qt-let-it-snow",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/LetItSnow.webp",
      alt: "Let it Snow",
      name: "Let it Snow",
      providerName: "Hacksaw",
    },
    MagicPiggy: {
      redirectUrl: "/casino/qt-magic-piggy",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/MagicPiggy.webp",
      alt: "Magic Piggy",
      name: "Magic Piggy",
      providerName: "Hacksaw",
    },
    MayanStackways: {
      redirectUrl: "/casino/qt-mayan-stackways",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/MayanStackways.webp",
      alt: "Mayan Stackways",
      name: "Mayan Stackways",
      providerName: "Hacksaw",
    },
    MiamiMultiplier: {
      redirectUrl: "/casino/qt-miami-multiplier",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/MiamiMultiplier.webp",
      alt: "Miami Multiplier",
      name: "Miami Multiplier",
      providerName: "Hacksaw",
    },
    MysteryMotel: {
      redirectUrl: "/casino/qt-mystery-motel",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/MysteryMotel.webp",
      alt: "Mystery Motel",
      name: "Mystery Motel",
      providerName: "Hacksaw",
    },
    OmNom: {
      redirectUrl: "/casino/qt-omnom",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/OmNom.webp",
      alt: "OmNom",
      name: "OmNom",
      providerName: "Hacksaw",
    },
    OutlawsInc: {
      redirectUrl: "/casino/qt-outlaws-inc",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/OutlawsInc.webp",
      alt: "Outlaws Inc",
      name: "Outlaws Inc",
      providerName: "Hacksaw",
    },
    PugLife: {
      redirectUrl: "/casino/qt-pug-life",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/PugLife.webp",
      alt: "Pug Life",
      name: "Pug Life",
      providerName: "Hacksaw",
    },
    RIPCity: {
      redirectUrl: "/casino/qt-rip-city",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/RIPCity.webp",
      alt: "RIP City",
      name: "RIP City",
      providerName: "Hacksaw",
    },
    RocketReels: {
      redirectUrl: "/casino/qt-rocket-reels",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/RocketReels.webp",
      alt: "Rocket Reels",
      name: "Rocket Reels",
      providerName: "Hacksaw",
    },
    Rotten: {
      redirectUrl: "/casino/qt-rotten",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Rotten.webp",
      alt: "Rotten",
      name: "Rotten",
      providerName: "Hacksaw",
    },
    StackEM: {
      redirectUrl: "/casino/qt-stackem",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/StackEM.webp",
      alt: "Stack'EM",
      name: "Stack'EM",
      providerName: "Hacksaw",
    },
    Stickem: {
      redirectUrl: "/casino/qt-stick-em",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Stickem.webp",
      alt: "Stick ‘em",
      name: "Stick ‘em",
      providerName: "Hacksaw",
    },
    Stormforged: {
      redirectUrl: "/casino/qt-stormforged",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Stormforged.webp",
      alt: "Stormforged",
      name: "Stormforged",
      providerName: "Hacksaw",
    },
    TastyTreats: {
      redirectUrl: "/casino/qt-tasty-treats",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/TastyTreats.webp",
      alt: "Tasty Treats",
      name: "Tasty Treats",
      providerName: "Hacksaw",
    },
    TempleOfTorment: {
      redirectUrl: "/casino/qt-temple-of-torment",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/TempleOfTorment.webp",
      alt: "Temple of Torment",
      name: "Temple of Torment",
      providerName: "Hacksaw",
    },
    TheBoweryBoys: {
      redirectUrl: "/casino/qt-the-bowery-boys",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/TheBoweryBoys.webp",
      alt: "The Bowery Boys",
      name: "The Bowery Boys",
      providerName: "Hacksaw",
    },
    TheRespinners: {
      redirectUrl: "/casino/qt-the-respinners",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/TheRespinners.webp",
      alt: "The Respinners",
      name: "The Respinners",
      providerName: "Hacksaw",
    },
    TimeSpinners: {
      redirectUrl: "/casino/qt-time-spinners",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/TimeSpinners.webp",
      alt: "Time Spinners",
      name: "Time Spinners",
      providerName: "Hacksaw",
    },
    ToshiVideoClub: {
      redirectUrl: "/casino/qt-toshi-video-club",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/ToshiVideoClub.webp",
      alt: "Toshi Video Club",
      name: "Toshi Video Club",
      providerName: "Hacksaw",
    },
    UndeadFortune: {
      redirectUrl: "/casino/qt-undead-fortune",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/UndeadFortune.webp",
      alt: "Undead Fortune",
      name: "Undead Fortune",
      providerName: "Hacksaw",
    },
    WarriorWays: {
      redirectUrl: "/casino/qt-warrior-ways",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/WarriorWays.webp",
      alt: "Warrior Ways",
      name: "Warrior Ways",
      providerName: "Hacksaw",
    },
    Xpander: {
      redirectUrl: "/casino/qt-xpander",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Xpander.webp",
      alt: "Xpander",
      name: "Xpander",
      providerName: "Hacksaw",
    },
    FeelTheBeat: {
      redirectUrl: "/casino/qt-feel-the-beat",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/FeelTheBeat.webp",
      alt: "Feel the Beat",
      name: "Feel the Beat",
      providerName: "Hacksaw",
    },
    BeamBoys: {
      redirectUrl: "/casino/qt-beam-boys",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/BeamBoys.webp",
      alt: "Beam Boys",
      name: "Beam Boys",
      providerName: "Hacksaw",
    },
    Baccarat: {
      redirectUrl: "/casino/qt-baccarat",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Baccarat.webp",
      alt: "Baccarat",
      name: "Baccarat",
      providerName: "Hacksaw",
    },
    FistOfDestruction: {
      redirectUrl: "/casino/qt-fist-of-destruction",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/FistOfDestruction.webp",
      alt: "Fist of Destruction",
      name: "Fist of Destruction",
      providerName: "Hacksaw",
    },
    DawnOfKings: {
      redirectUrl: "/casino/qt-dawn-of-kings",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/DawnOfKings.webp",
      alt: "Dawn of Kings",
      name: "Dawn of Kings",
      providerName: "Hacksaw",
    },
    BouncyBombs: {
      redirectUrl: "/casino/qt-bouncy-bombs",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/BouncyBombs.webp",
      alt: "Bouncy Bombs",
      name: "Bouncy Bombs",
      providerName: "Hacksaw",
    },
    RustyAndCurly: {
      redirectUrl: "/casino/qt-rusty-and-curly",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/RustyAndCurly.webp",
      alt: "Rusty & Curly",
      name: "Rusty & Curly",
      providerName: "Hacksaw",
    },
    // ScratchAMillion: {
    //   redirectUrl: "/casino/qt-scratch-a-million",
    //   code: "",
    //   casino: "Hacksaw",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/hacksaw/ScratchAMillion.webp",
    //   alt: "Scratch a Million",
    //   name: "Scratch a Million",
    //  providerName: "Hacksaw",
    // },
    // InstaCubes: {
    //   redirectUrl: "/casino/qt-insta-cubes",
    //   code: "",
    //   casino: "Hacksaw",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/new/hacksaw/InstaCubes.webp",
    //   alt: "Insta Cubes",
    //   name: "Insta Cubes",
    //  providerName: "Hacksaw",
    // },
    LePharaoh: {
      redirectUrl: "/casino/aggaphacksawgaming-le-pharaoh",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/LePharaoh.webp",
      alt: "Le Pharaoh",
      name: "Le Pharaoh",
      providerName: "Hacksaw",
    },
    OctoAttack: {
      redirectUrl: "/casino/aggaphacksawgaming-octo-attack",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/OctoAttack.webp",
      alt: "Octo Attack",
      name: "Octo Attack",
      providerName: "Hacksaw",
    },
    EvilEyes: {
      redirectUrl: "/casino/aggaphacksawgaming-evil-eyes",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/EvilEyes.webp",
      alt: "Evil Eyes",
      name: "Evil Eyes",
      providerName: "Hacksaw",
    },
    SpeedCrash: {
      redirectUrl: "/casino/aggaphacksawgaming-speed-crash",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/SpeedCrash.webp",
      alt: "Speed Crash",
      name: "Speed Crash",
      providerName: "Hacksaw",
    },
    Limbo: {
      redirectUrl: "/casino/aggaphacksawgaming-limbo",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Limbo.webp",
      alt: "Limbo",
      name: "Limbo",
      providerName: "Hacksaw",
    },
    DonnyDough: {
      redirectUrl: "/casino/aggaphacksawgaming-donny-dough",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/DonnyDough.webp",
      alt: "Donny Dough",
      name: "Donny Dough",
      providerName: "Hacksaw",
    },
    SixSixSix: {
      redirectUrl: "/casino/aggaphacksawgaming-sixsixsix",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/SixSixSix.webp",
      alt: "SixSixSix",
      name: "SixSixSix",
      providerName: "Hacksaw",
    },
    Dice: {
      redirectUrl: "/casino/qt-dice",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/Dice.webp",
      alt: "Dice",
      name: "Dice",
      providerName: "Hacksaw",
    },
    TaiTheToad: {
      redirectUrl: "/casino/qt-tai-the-toad",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/TaiTheToad.webp",
      alt: "Tai the Toad",
      name: "Tai the Toad",
      providerName: "Hacksaw",
    },
    TwistedLabs: {
      redirectUrl: "/casino/qt-twisted-labs",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/TwistedLabs.webp",
      alt: "Twisted Labs",
      name: "Twisted Labs",
      providerName: "Hacksaw",
    },
    ZeZeus: {
      redirectUrl: "/casino/qt-ze-zeus",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/ZeZeus.webp",
      alt: "Ze Zeus",
      name: "Ze Zeus",
      providerName: "Hacksaw",
    },
    CursedCrypt: {
      redirectUrl: "/casino/qt-cursed-crypt",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/CursedCrypt.webp",
      alt: "Cursed Crypt",
      name: "Cursed Crypt",
      providerName: "Hacksaw",
    },
    SlayersInc: {
      redirectUrl: "/casino/qt-slayers-inc",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/SlayersInc.webp",
      alt: "Slayers Inc",
      name: "Slayers Inc",
      providerName: "Hacksaw",
    },
    JellySlice: {
      redirectUrl: "/casino/qt-jelly-slice",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/JellySlice.webp",
      alt: "Jelly Slice",
      name: "Jelly Slice",
      providerName: "Hacksaw",
    },
    KeepEm: {
      redirectUrl: "/casino/qt-keep-em",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/KeepEm.webp",
      alt: "Keep 'Em",
      name: "Keep 'Em",
      providerName: "Hacksaw",
    },
    DivineDrop: {
      redirectUrl: "/casino/qt-divine-drop",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/DivineDrop.webp",
      alt: "Divine Drop",
      name: "Divine Drop",
      providerName: "Hacksaw",
    },
    OrbOfDestiny: {
      redirectUrl: "/casino/qt-orb-of-destiny",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/OrbOfDestiny.webp",
      alt: "Orb of Destiny",
      name: "Orb of Destiny",
      providerName: "Hacksaw",
    },
    CashCrew: {
      redirectUrl: "/casino/qt-cash-crew",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/CashCrew.webp",
      alt: "Cash Crew",
      name: "Cash Crew",
      providerName: "Hacksaw",
    },
    CloudPrincess: {
      redirectUrl: "/casino/aggaphacksawgaming-cloud-princess",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/CloudPrincess.webp",
      alt: "Cloud Princess",
      name: "Cloud Princess",
      providerName: "Hacksaw",
    },
    GetTheCheese: {
      redirectUrl: "/casino/aggaphacksawgaming-get-the-cheese",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/GetTheCheese.webp",
      alt: "Get The Cheese",
      name: "Get The Cheese",
      providerName: "Hacksaw",
    },
    RiseOfYmir: {
      redirectUrl: "/casino/aggaphacksawgaming-rise-of-ymir",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/RiseOfYmir.webp",
      alt: "Rise of Ymir",
      name: "Rise of Ymir",
      providerName: "Hacksaw",
    },
    WingsOfHorus: {
      redirectUrl: "/casino/aggaphacksawgaming-wings-of-horus",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/WingsOfHorus.webp",
      alt: "Wings of Horus",
      name: "Wings of Horus",
      providerName: "Hacksaw",
    },
    DuelAtDawn: {
      redirectUrl: "/casino/aggaphacksawgaming-duel-at-dawn",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/DuelAtDawn.webp",
      alt: "Duel at Dawn",
      name: "Duel at Dawn",
      providerName: "Hacksaw",
    },
    LeViking: {
      redirectUrl: "/casino/qt-volatile-vikings",
      code: "",
      casino: "Hacksaw",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/new/hacksaw/LeViking.webp",
      alt: "Le Viking",
      name: "Le Viking",
      providerName: "Hacksaw",
    },
  },

  // galaxsys: {
  //   ScratchMap: {
  //     redirectUrl: "/casino/qtechgalaxsys-scratch-map",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/ScratchMap.webp",
  //     alt: "Scratch Map",
  //     name: "Scratch Map",
  //     providerName: "Galaxsys",
  //   },
  //   Atlantis: {
  //     redirectUrl: "/casino/qtechgalaxsys-atlantis",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/Atlantis.webp",
  //     alt: "Atlantis",
  //     name: "Atlantis",
  //     providerName: "Galaxsys",
  //   },
  //   CashShow: {
  //     redirectUrl: "/casino/qtechgalaxsys-cash-show",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/CashShow.webp",
  //     alt: "Cash Show",
  //     name: "Cash Show",
  //     providerName: "Galaxsys",
  //   },
  //   CoinFlip: {
  //     redirectUrl: "/casino/qtechgalaxsys-coin-flip",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/CoinFlip.webp",
  //     alt: "Coin Flip",
  //     name: "Coin Flip",
  //     providerName: "Galaxsys",
  //   },
  //   Crash: {
  //     redirectUrl: "/casino/qtechgalaxsys-crash",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/Crash.webp",
  //     alt: "Crash",
  //     name: "Crash",
  //     providerName: "Galaxsys",
  //   },
  //   Crasher: {
  //     redirectUrl: "/casino/qtechgalaxsys-crasher",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/Crasher.webp",
  //     alt: "Crasher",
  //     name: "Crasher",
  //     providerName: "Galaxsys",
  //   },
  //   JungleWheel: {
  //     redirectUrl: "/casino/qtechgalaxsys-jungle-wheel",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/JungleWheel.webp",
  //     alt: "Jungle Wheel",
  //     name: "Jungle Wheel",
  //     providerName: "Galaxsys",
  //   },
  //   FMines: {
  //     redirectUrl: "/casino/qtechgalaxsys-f-mines",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/FMines.webp",
  //     alt: "F Mines",
  //     name: "F Mines",
  //     providerName: "Galaxsys",
  //   },
  //   GoldenRa: {
  //     redirectUrl: "/casino/qtechgalaxsys-golden-ra",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/GoldenRa.webp",
  //     alt: "Golden Ra",
  //     name: "Golden Ra",
  //     providerName: "Galaxsys",
  //   },
  //   Hilo: {
  //     redirectUrl: "/casino/qtechgalaxsys-hilo",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/Hilo.webp",
  //     alt: "Hilo",
  //     name: "Hilo",
  //     providerName: "Galaxsys",
  //   },
  //   Maestro: {
  //     redirectUrl: "/casino/qtechgalaxsys-maestro",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/Maestro.webp",
  //     alt: "Maestro",
  //     name: "Maestro",
  //     providerName: "Galaxsys",
  //   },
  //   MrThimbl: {
  //     redirectUrl: "/casino/qtechgalaxsys-mr-thimbl",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/MrThimbl.webp",
  //     alt: "Mr. Thimbl",
  //     name: "Mr. Thimbl",
  //     providerName: "Galaxsys",
  //   },
  //   NinjaCrash: {
  //     redirectUrl: "/casino/qtechgalaxsys-ninja-crash",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/NinjaCrash.webp",
  //     alt: "Ninja Crash",
  //     name: "Ninja Crash",
  //     providerName: "Galaxsys",
  //   },
  //   Penalty: {
  //     redirectUrl: "/casino/qtechgalaxsys-penalty",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/Penalty.webp",
  //     alt: "Penalty",
  //     name: "Penalty",
  //     providerName: "Galaxsys",
  //   },
  //   Plinkoman: {
  //     redirectUrl: "/casino/qtechgalaxsys-plinkoman",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/Plinkoman.webp",
  //     alt: "Plinkoman",
  //     name: "Plinkoman",
  //     providerName: "Galaxsys",
  //   },
  //   Rocketon: {
  //     redirectUrl: "/casino/qtechgalaxsys-rocketon",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/Rocketon.webp",
  //     alt: "Rocketon",
  //     name: "Rocketon",
  //     providerName: "Galaxsys",
  //   },
  //   TurboMines: {
  //     redirectUrl: "/casino/qtechgalaxsys-turbo-mines",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/TurboMines.webp",
  //     alt: "Turbo Mines",
  //     name: "Turbo Mines",
  //     providerName: "Galaxsys",
  //   },
  //   BingoStar: {
  //     redirectUrl: "/casino/qtechgalaxsys-bingo-star",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/BingoStar.webp",
  //     alt: "Bingo Star",
  //     name: "Bingo Star",
  //     providerName: "Galaxsys",
  //   },
  //   Keno10Minute1: {
  //     redirectUrl: "/casino/qtechgalaxsys-keno-10-1-minute",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/Keno10Minute1.webp",
  //     alt: "Keno 10 (1 Minute)",
  //     name: "Keno 10 (1 Minute)",
  //     providerName: "Galaxsys",
  //   },
  //   Keno10Minute2: {
  //     redirectUrl: "/casino/qtechgalaxsys-keno-10-2-minute",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/Keno10Minute2.webp",
  //     alt: "Keno 10 (2 Minute)",
  //     name: "Keno 10 (2 Minute)",
  //     providerName: "Galaxsys",
  //   },
  //   Keno8Minute1: {
  //     redirectUrl: "/casino/qtechgalaxsys-keno-8-1-minute",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/Keno8Minute1.webp",
  //     alt: "Keno 8 (1 Minute)",
  //     name: "Keno 8 (1 Minute)",
  //     providerName: "Galaxsys",
  //   },
  //   Keno8Minute2: {
  //     redirectUrl: "/casino/qtechgalaxsys-keno-8-2-minute",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/Keno8Minute2.webp",
  //     alt: "Keno 8 (2 Minute)",
  //     name: "Keno 8 (2 Minute)",
  //     providerName: "Galaxsys",
  //   },
  //   KenoExpress: {
  //     redirectUrl: "/casino/qtechgalaxsys-keno-express",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/KenoExpress.webp",
  //     alt: "Keno Express",
  //     name: "Keno Express",
  //     providerName: "Galaxsys",
  //   },
  //   BlackJack: {
  //     redirectUrl: "/casino/qtechgalaxsys-blackjack",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/BlackJack.webp",
  //     alt: "BlackJack",
  //     name: "BlackJack",
  //     providerName: "Galaxsys",
  //   },
  //   RouletteX: {
  //     redirectUrl: "/casino/qtechgalaxsys-roulette-x",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/RouletteX.webp",
  //     alt: "Roulette X",
  //     name: "Roulette X",
  //     providerName: "Galaxsys",
  //   },

  //   // BackgammonAsian: {
  //   //   redirectUrl: "/casino/qtechgalaxsys-backgammon-asian-u6980",
  //   //   code: "",
  //   //   casino: "Galaxsys",
  //   //   provider: "Qtech",
  //   //   homeUrl: "http://localhost:3000/Casino",
  //   //   imgUrl: "./images/qtech/galaxsys/BackgammonAsian.webp",
  //   //   alt: "Backgammon Asian",
  //   //   name: "Backgammon Asian",
  //   //   providerName: "Galaxsys",
  //   // },
  //   SicBo: {
  //     redirectUrl: "/casino/qtechgalaxsys-sicbo",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/SicBoGalaxsys.webp",
  //     alt: "SicBo",
  //     name: "SicBo",
  //     providerName: "Galaxsys",
  //   },
  //   CosmoSaga: {
  //     redirectUrl: "/casino/qtechgalaxsys-cosmo-saga",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/CosmoSaga.webp",
  //     alt: "Cosmo Saga",
  //     name: "Cosmo Saga",
  //     providerName: "Galaxsys",
  //   },
  //   DrShocker: {
  //     redirectUrl: "/casino/qtechgalaxsys-dr-shocker",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/DrShocker.webp",
  //     alt: "Dr Shocker",
  //     name: "Dr Shocker",
  //     providerName: "Galaxsys",
  //   },
  //   HotGear: {
  //     redirectUrl: "/casino/qtechgalaxsys-hot-gear",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/HotGear.webp",
  //     alt: "Hot Gear",
  //     name: "Hot Gear",
  //     providerName: "Galaxsys",
  //   },
  //   LottoBoom: {
  //     redirectUrl: "/casino/qtechgalaxsys-lotto-boom",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/LottoBoom.webp",
  //     alt: "Lotto Boom",
  //     name: "Lotto Boom",
  //     providerName: "Galaxsys",
  //   },
  //   TowerRush: {
  //     redirectUrl: "/casino/qtechgalaxsys-tower-rush",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/TowerRush.webp",
  //     alt: "Tower Rush",
  //     name: "Tower Rush",
  //     providerName: "Galaxsys",
  //   },
  //   LimboCrash: {
  //     redirectUrl: "/casino/qtechgalaxsys-limbo-crash",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/LimboCrash.webp",
  //     alt: "Limbo Crash",
  //     name: "Limbo Crash",
  //     providerName: "Galaxsys",
  //   },
  //   SlapShot: {
  //     redirectUrl: "/casino/qtechgalaxsys-slap-shot",
  //     code: "",
  //     casino: "Galaxsys",
  //     provider: "Qtech",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/qtech/galaxsys/SlapShot.webp",
  //     alt: "Slap Shot",
  //     name: "Slap Shot",
  //     providerName: "Galaxsys",
  //   },
  // },

  smartSoft: {
    JetX: {
      redirectUrl: "/casino/aggapsmartsoftgaming-jetx",
      code: "",
      casino: "SmartSoft",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/smartsoft/JetX.webp",
      alt: "JetX",
      name: "JetX",
      providerName: "SmartSoft",
    },
    Cappadocia: {
      redirectUrl: "/casino/aggapsmartsoftgaming-cappadocia",
      code: "",
      casino: "SmartSoft",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/smartsoft/Cappadocia.webp",
      alt: "Cappadocia",
      name: "Cappadocia",
      providerName: "SmartSoft",
    },
    JetX3: {
      redirectUrl: "/casino/aggapsmartsoftgaming-jetx3",
      code: "",
      casino: "SmartSoft",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/smartsoft/JetX3.webp",
      alt: "JetX3",
      name: "JetX3",
      providerName: "SmartSoft",
    },
    SpinX: {
      redirectUrl: "/casino/aggapsmartsoftgaming-spinx",
      code: "",
      casino: "SmartSoft",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/smartsoft/SpinX.webp",
      alt: "SpinX",
      name: "SpinX",
      providerName: "SmartSoft",
    },
    // Balloon: {
    //   redirectUrl: "/casino/qtechsmartsoft-balloon",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/smartsoft/Balloon.webp",
    //   alt: "Balloon",
    //   name: "Balloon",
    //   providerName: "SmartSoft",
    // },
    CricketX: {
      redirectUrl: "/casino/aggapsmartsoftgaming-cricketx",
      code: "",
      casino: "SmartSoft",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/smartsoft/CricketX.webp",
      alt: "CricketX",
      name: "CricketX",
      providerName: "SmartSoft",
    },
    PlinkoX: {
      redirectUrl: "/casino/aggapsmartsoftgaming-plinkox",
      code: "",
      casino: "SmartSoft",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/smartsoft/PlinkoX.webp",
      alt: "PlinkoX",
      name: "PlinkoX",
      providerName: "SmartSoft",
    },
    FootballX: {
      redirectUrl: "/casino/aggapsmartsoftgaming-footballx",
      code: "",
      casino: "SmartSoft",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/smartsoft/FootballX.webp",
      alt: "FootballX",
      name: "FootballX",
      providerName: "SmartSoft",
    },
    // CrazyHuntX: {
    //   redirectUrl: "/casino/qtechsmartsoft-crazy-huntx-u7133",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/smartsoft/CrazyHuntX.webp",
    //   alt: "Crazy HuntX",
    //   name: "Crazy HuntX",
    //   providerName: "SmartSoft",
    // },
    // DoubleX: {
    //   redirectUrl: "/casino/qtechsmartsoft-doublex-u4408",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/smartsoft/DoubleX.webp",
    //   alt: "DoubleX",
    //   name: "DoubleX",
    //   providerName: "SmartSoft",
    // },
    TowerX: {
      redirectUrl: "/casino/aggapsmartsoftgaming-towerx",
      code: "",
      casino: "SmartSoft",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/smartsoft/TowerX.webp",
      alt: "TowerX",
      name: "TowerX",
      providerName: "SmartSoft",
    },
    // Jokers4Bonuses: {
    //   redirectUrl: "/casino/qtechsmartsoft-jokers-4-bonuses-u3686",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/smartsoft/Jokers4Bonuses.webp",
    //   alt: "Joker's 4 Bonuses",
    //   name: "Joker's 4 Bonuses",
    //   providerName: "SmartSoft",
    // },
    // Viking: {
    //   redirectUrl: "/casino/qtechsmartsoft-viking-u3550",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/smartsoft/Viking.webp",
    //   alt: "Viking",
    //   name: "Viking",
    //   providerName: "SmartSoft",
    // },
    // Aztec: {
    //   redirectUrl: "/casino/qtechsmartsoft-aztec-u9211",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/smartsoft/Aztec.webp",
    //   alt: "Aztec",
    //   name: "Aztec",
    //   providerName: "SmartSoft",
    // },
    // Cowboy: {
    //   redirectUrl: "/casino/qtechsmartsoft-cowboy-u5088",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/smartsoft/Cowboy.webp",
    //   alt: "Cowboy",
    //   name: "Cowboy",
    //   providerName: "SmartSoft",
    // },
    // BookOfWin: {
    //   redirectUrl: "/casino/qtechsmartsoft-book-of-win-u2510",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/smartsoft/BookOfWin.webp",
    //   alt: "Book of Win",
    //   name: "Book of Win",
    //   providerName: "SmartSoft",
    // },
    Samurai: {
      redirectUrl: "/casino/aggapsmartsoftgaming-samurai",
      code: "",
      casino: "SmartSoft",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/smartsoft/Samurai.webp",
      alt: "Samurai",
      name: "Samurai",
      providerName: "SmartSoft",
    },
    // MoonStone: {
    //   redirectUrl: "/casino/qtechsmartsoft-moonstone-u9590",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/smartsoft/MoonStone.webp",
    //   alt: "MoonStone",
    //   name: "MoonStone",
    //   providerName: "SmartSoft",
    // },
    // Apollo: {
    //   redirectUrl: "/casino/qtechsmartsoft-apollo-u8093",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/smartsoft/Apollo.webp",
    //   alt: "Apollo",
    //   name: "Apollo",
    //   providerName: "SmartSoft",
    // },
    // Evolution: {
    //   redirectUrl: "/casino/qtechsmartsoft-evolution-u7308",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/smartsoft/Evolution.webp",
    //   alt: "Evolution",
    //   name: "Evolution",
    //   providerName: "SmartSoft",
    // },
    BurningIce: {
      redirectUrl: "/casino/aggapsmartsoftgaming-burning-ice",
      code: "",
      casino: "SmartSoft",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/smartsoft/BurningIce.webp",
      alt: "Burning Ice",
      name: "Burning Ice",
      providerName: "SmartSoft",
    },
    // MagicGarden: {
    //   redirectUrl: "/casino/qtechsmartsoft-magic-garden-u4134",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/smartsoft/MagicGarden.webp",
    //   alt: "Magic Garden",
    //   name: "Magic Garden",
    //   providerName: "SmartSoft",
    // },
    BurningIce10: {
      redirectUrl: "/casino/aggapsmartsoftgaming-burning-ice-10",
      code: "",
      casino: "SmartSoft",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/smartsoft/BurningIce10.webp",
      alt: "Burning Ice 10",
      name: "Burning Ice 10",
      providerName: "SmartSoft",
    },
    // MagicGarden10: {
    //   redirectUrl: "/casino/qtechsmartsoft-magic-garden-10-u4108",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/smartsoft/MagicGarden10.webp",
    //   alt: "Magic Garden 10",
    //   name: "Magic Garden 10",
    //   providerName: "SmartSoft",
    // },
    BurningIce40: {
      redirectUrl: "/casino/aggapsmartsoftgaming-burning-ice-40",
      code: "",
      casino: "SmartSoft",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/smartsoft/BurningIce40.webp",
      alt: "Burning Ice 40",
      name: "Burning Ice 40",
      providerName: "SmartSoft",
    },
    // MagicGarden40: {
    //   redirectUrl: "/casino/qtechsmartsoft-magic-garden-40-u6329",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/smartsoft/MagicGarden40.webp",
    //   alt: "Magic Garden 40",
    //   name: "Magic Garden 40",
    //   providerName: "SmartSoft",
    // },
    // Dark: {
    //   redirectUrl: "/casino/qtechsmartsoft-dark-u5991",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/smartsoft/Dark.webp",
    //   alt: "Dark",
    //   name: "Dark",
    //   providerName: "SmartSoft",
    // },
    // WorldWarII: {
    //   redirectUrl: "/casino/qtechsmartsoft-world-war-ii-u8573",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/smartsoft/WorldWarII.webp",
    //   alt: "World War II",
    //   name: "World War II",
    //   providerName: "SmartSoft",
    // },
    // SummerCocktail: {
    //   redirectUrl: "/casino/qtechsmartsoft-summer-cocktail-u3240",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/smartsoft/SummerCocktail.webp",
    //   alt: "Summer Cocktail",
    //   name: "Summer Cocktail",
    //   providerName: "SmartSoft",
    // },
    // Dark100: {
    //   redirectUrl: "/casino/qtechsmartsoft-dark-100-u9404",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/smartsoft/Dark100.webp",
    //   alt: "Dark 100",
    //   name: "Dark 100",
    //   providerName: "SmartSoft",
    // },
    Vampires: {
      redirectUrl: "/casino/aggapsmartsoftgaming-vampires",
      code: "",
      casino: "SmartSoft",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/smartsoft/Vampires.webp",
      alt: "Vampires",
      name: "Vampires",
      providerName: "SmartSoft",
    },
    // TheKingdomOfTheElves: {
    //   redirectUrl: "/casino/qtechsmartsoft-the-kingdom-of-the-elves-u4650",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/smartsoft/TheKingdomOfTheElves.webp",
    //   alt: "The Kingdom of The Elves",
    //   name: "The Kingdom of The Elves",
    //   providerName: "SmartSoft",
    // },
    MultiHot5: {
      redirectUrl: "/casino/aggapsmartsoftgaming-multi-hot-5",
      code: "",
      casino: "SmartSoft",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/smartsoft/MultiHot5.webp",
      alt: "Multi Hot 5",
      name: "Multi Hot 5",
      providerName: "SmartSoft",
    },
    // Zombies: {
    //   redirectUrl: "/casino/qtechsmartsoft-zombies-u2367",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/smartsoft/Zombies.webp",
    //   alt: "Zombies",
    //   name: "Zombies",
    //   providerName: "SmartSoft",
    // },
    WildJungle: {
      redirectUrl: "/casino/aggapsmartsoftgaming-wild-jungle",
      code: "",
      casino: "SmartSoft",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/smartsoft/WildJungle.webp",
      alt: "Wild Jungle",
      name: "Wild Jungle",
      providerName: "SmartSoft",
    },
    // SweetCocktail: {
    //   redirectUrl: "/casino/qtechsmartsoft-sweet-cocktail-u8472",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/smartsoft/SweetCocktail.webp",
    //   alt: "Sweet Cocktail",
    //   name: "Sweet Cocktail",
    //   providerName: "SmartSoft",
    // },
    // CrazyApe: {
    //   redirectUrl: "/casino/qtechsmartsoft-crazy-ape-u1544",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/smartsoft/CrazyApe.webp",
    //   alt: "Crazy Ape",
    //   name: "Crazy Ape",
    //   providerName: "SmartSoft",
    // },
    // ParaDice10: {
    //   redirectUrl: "/casino/qtechsmartsoft-para-dice-10-u6786",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/smartsoft/ParaDice10.webp",
    //   alt: "Para Dice 10",
    //   name: "Para Dice 10",
    //   providerName: "SmartSoft",
    // },
    // Babylon: {
    //   redirectUrl: "/casino/qtechsmartsoft-babylon-u1392",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/smartsoft/Babylon.webp",
    //   alt: "Babylon",
    //   name: "Babylon",
    //   providerName: "SmartSoft",
    // },
    GeniesBonanza: {
      redirectUrl: "/casino/aggapsmartsoftgaming-genies-bonanza",
      code: "",
      casino: "SmartSoft",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/smartsoft/GeniesBonanza.webp",
      alt: "Genie's Bonanza",
      name: "Genie's Bonanza",
      providerName: "SmartSoft",
    },
    MultiHotWays: {
      redirectUrl: "/casino/aggapsmartsoftgaming-multi-hot-ways",
      code: "",
      casino: "SmartSoft",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/qtech/smartsoft/MultiHotWays.webp",
      alt: "Multi Hot Ways",
      name: "Multi Hot Ways",
      providerName: "SmartSoft",
    },
    // VirtualRoulette: {
    //   redirectUrl: "/casino/qtechsmartsoft-virtual-roulette-u3619",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/smartsoft/VirtualRoulette.webp",
    //   alt: "Virtual Roulette",
    //   name: "Virtual Roulette",
    //   providerName: "SmartSoft",
    // },
    // VirtualBurningRoulette: {
    //   redirectUrl: "/casino/qtechsmartsoft-virtual-burning-roulette-u5010",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/smartsoft/VirtualBurningRoulette.webp",
    //   alt: "Virtual Burning Roulette",
    //   name: "Virtual Burning Roulette",
    //   providerName: "SmartSoft",
    // },
    // BonusRoulette: {
    //   redirectUrl: "/casino/qtechsmartsoft-bonus-roulette-u2578",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/smartsoft/BonusRoulette.webp",
    //   alt: "Bonus Roulette",
    //   name: "Bonus Roulette",
    //   providerName: "SmartSoft",
    // },
    // PersonalRoulette: {
    //   redirectUrl: "/casino/qtechsmartsoft-personal-roulette-u1044",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/smartsoft/PersonalRoulette.webp",
    //   alt: "Personal Roulette",
    //   name: "Personal Roulette",
    //   providerName: "SmartSoft",
    // },
    // VirtualClassicRoulette: {
    //   redirectUrl: "/casino/qtechsmartsoft-virtual-classic-roulette-u1605",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/smartsoft/VirtualClassicRoulette.webp",
    //   alt: "Virtual Classic Roulette",
    //   name: "Virtual Classic Roulette",
    //   providerName: "SmartSoft",
    // },
    // FrenchKeno: {
    //   redirectUrl: "/casino/qtechsmartsoft-french-keno-u9013",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/smartsoft/FrenchKeno.webp",
    //   alt: "French Keno",
    //   name: "French Keno",
    //   providerName: "SmartSoft",
    // },
    // RussianKeno: {
    //   redirectUrl: "/casino/qtechsmartsoft-russian-keno-u1034",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/smartsoft/RussianKeno.webp",
    //   alt: "Russian Keno",
    //   name: "Russian Keno",
    //   providerName: "SmartSoft",
    // },
    // VIPKeno: {
    //   redirectUrl: "/casino/qtechsmartsoft-vip-keno-u7016",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/smartsoft/VIPKeno.webp",
    //   alt: "VIP Keno",
    //   name: "VIP Keno",
    //   providerName: "SmartSoft",
    // },
    // Argo: {
    //   redirectUrl: "/casino/qtechsmartsoft-argo-u6076",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/qtech/smartsoft/Argo.webp",
    //   alt: "Argo",
    //   name: "Argo",
    //   providerName: "SmartSoft",
    // },
  },
};
